import utils from '../../../utils/utils';

function sortBy<T>(data: Array<T>, field: string): Array<T> {
    return data.sort((a, b) => {
        if (a[field] < b[field]) {
            return 1;
        }
        if (a[field] > b[field]) {
            return -1;
        }
        return 0;
    });
}

export const transform = {
    pieChart: (data: { items: any[] }, fieldName: string | number) => {
        const arrayObj =
            data &&
            data.items.map((item) => ({
                id: item[fieldName] || 'Unknown',
                label: item[fieldName] || 'Unknown',
                value: item.COUNT,
            }));
        return arrayObj && sortBy(arrayObj, 'id');
    },
    barChart: (
        data: { items: any[] },
        groupBy: string | number,
        relativeData?: any
    ) => {
        let returnData = {};
        const keys = [];
        const transformedData = [];

        if (data && data.items && data.items.length > 0) {
            // eslint-disable-next-line array-callback-return
            data.items.map((q, i) => {
                let groupedByValue = q[groupBy];
                if (relativeData) {
                    const findGroupValue = relativeData.find(
                        (o) => o.id === q[groupBy]
                    );
                    if (findGroupValue) {
                        groupedByValue = findGroupValue.name;
                    }
                }
                const index = transformedData.findIndex(
                    (i) => i.groupedBy === groupedByValue
                );
                if (index < 0) {
                    const obj = {
                        groupedBy: groupedByValue,
                        Count: q.COUNT,
                    };
                    transformedData.push(obj);
                } else {
                    transformedData[index]['Count'] = q.COUNT;
                }

                const key = 'Count';
                if (!keys.includes(key)) {
                    keys.push(key);
                }
            });

            returnData = {
                data: sortBy(transformedData, 'Count'),
                keys,
            };
        }

        return returnData;
    },
    calendar: (data: { items: any[] }, chart: string | number) => {
        const now = new Date();
        const date = new Date(now);
        const yearToDate = date.setDate(now.getDate() - 365);
        const values = [];
        data &&
            data.items &&
            // eslint-disable-next-line array-callback-return
            data.items.map((dayItem) => {
                if (
                    dayItem[chart] > utils.formatDate(yearToDate, 'YYYY-MM-DD')
                ) {
                    values.push({
                        day: dayItem[chart],
                        value: dayItem.COUNT,
                    });
                }
            });
        return values;
    },
};
